import { defineStore } from "pinia";

export const UserInfo = defineStore('userInfo', {
    state: () => ({ listMonths: [], currentWeight: '', pickedYear: null, userInfo: '', yearsToPick: [], weightChange: '', cleanEntries: [] }),
    persist: true,
    getters: {

    },
    actions: {
        setCurrentWeight(entries) {
            const lastMonth = entries[Object.keys(entries).sort().reverse()[0]];
            this.currentWeight = lastMonth[lastMonth.length - 1].weight;
            this.weightChange = this.userInfo.currentWeight - this.currentWeight;
        },
        setListMonths(list) {


            this.listMonths = list;
        },
        setCleanEntries(list) {

            this.cleanEntries = list;
        },
        setYear(year) {
            this.pickedYear = year;
        },
        setYearsToPick(list) {

            this.yearsToPick = list;
        },
        setUserInfo(userInfo) {

            this.userInfo = userInfo;
            
            console.log('1', this.userInfo.currentWeight)
        }
    },



}) 